import { colors } from './colors';
import { size } from './size';

export const theme = {
  colors,
  size,
};
